import Vue from 'vue'

import Qs from 'qs'

class TicketBonuses {
  async indexTicket({ticketId, params}) {
    return await Vue.axios
      .get('app/ticket-bonuses/by-ticket/' + ticketId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async createTicket({ticketId, data}) {
    return await Vue.axios
      .post('app/ticket-bonuses/by-ticket/' + ticketId, data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/ticket-bonuses/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/ticket-bonuses/' + id, data)
  }

  async updateMass({data}) {
    return await Vue.axios
      .put('app/ticket-bonuses/mass', data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/ticket-bonuses/' + id)
  }
}

const ticketBonuses = new TicketBonuses()

export default ticketBonuses
